import React, { useState, useEffect } from 'react';
import {
  Box,
  Container,
  CircularProgress
} from '@mui/material';
import { useParams, useNavigate } from 'react-router-dom';
import paymentService from '../services/paymentService';
import orderService from '../services/orderService';

const PaymentFailedPage = () => {
  const { paymentId } = useParams();
  const navigate = useNavigate();
  const [, setLoading] = useState(true);

  useEffect(() => {
    fetchPaymentDataAndRedirect();
  }, [paymentId]); // eslint-disable-line react-hooks/exhaustive-deps

  const fetchPaymentDataAndRedirect = async () => {
    try {
      setLoading(true);

      // Get payment data from API
      const paymentData = await paymentService.getPaymentStatus(paymentId);

      // Fetch order data if we have an order ID
      let orderData = null;
      if (paymentData.order_id) {
        try {
          orderData = await orderService.getOrder(paymentData.order_id);
        } catch (orderError) {
          console.warn('Could not fetch order data:', orderError);
          // Continue without order data
        }
      }

      // Build menu URL with payment parameters
      const merchantParam = orderData ? `merchant=${orderData.merchant}` : '';
      const tableParam = orderData?.table ? `&table=${orderData.table.id || orderData.table}` : '';

      // Redirect to menu page with payment parameters
      const menuUrl = `/menu?${merchantParam}${tableParam}&payment=failed&payment_id=${paymentId}&order_id=${paymentData.order_id}`;
      navigate(menuUrl);

    } catch (err) {
      console.error('Error fetching payment data:', err);
      // Fallback: redirect to menu without parameters
      navigate('/menu');
    }
  };


  // Show loading while fetching data and redirecting
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minHeight: '60vh', justifyContent: 'center' }}>
        <CircularProgress size={60} sx={{ mb: 2 }} />
        <Box sx={{ textAlign: 'center' }}>
          Redirecting to menu page...
        </Box>
      </Box>
    </Container>
  );
};

export default PaymentFailedPage;
